import React from 'react'
// import { TouchableHighlight } from 'react-native'
import { Text, View } from '../../Components'

const Link = ({ text, textSettings, ...rest }) => (
  <View {...rest} underlayColor="transparent">
    <Text as="hint" color="highlight" {...textSettings} style={{ textDecorationLine: 'underline' }}>
      {text}
    </Text>
  </View>
)

Link.defaultProps = {
  textSettings: {},
}

export default Link
